// $(document).ready(function () {
//   const $track = $(".word-track");
//   const $words = $(".word-track .word");
//   const wordHeight = $(".word").outerHeight();
//   //console.log(wordHeight);
//   let index = 1; // Middle item is centered
//   function slideWords() {
//     $words.removeClass("active");
//     $words.eq(index).addClass("active");
//     const offset = (index - 1) * wordHeight;
//     $track.css("transform", `translateY(-${offset}px)`);
//     index++;
//     if (index >= $words.length - 1) {
//       setTimeout(() => {
//         $track.css("transition", "none");
//         $track.css("transform", "translateY(0)");
//         index = 1;
//         $words.removeClass("active");
//         $words.eq(index).addClass("active");
//         setTimeout(() => {
//           $track.css("transition", "transform 0.6s ease-in-out");
//         }, 50);
//       }, 1000);
//     }
//   }
//   $words.eq(index).addClass("active");
//   setInterval(slideWords, 1500);
// });

$(document).ready(function () {
  const $track = $(".word-track");
  const $words = $(".word-track .word");
  const wordHeight = $(".word").outerHeight();
  let index = 1;
  const animationTime = 1400; // shared duration for both text slide & image fade
  const intervalTime = 2800; // time between slides

  function updateImages($word) {
    const leftImg = $word.data("left");
    const rightImg = $word.data("right");

    const $left = $("#left-banner-img");
    const $right = $("#right-banner-img");

    $left.stop(true, true).fadeOut(animationTime / 2, function () {
      if (leftImg) {
        $left.attr("src", leftImg).fadeIn(animationTime / 2);
      } else {
        $left.hide();
      }
    });

    $right.stop(true, true).fadeOut(animationTime / 2, function () {
      if (rightImg) {
        $right.attr("src", rightImg).fadeIn(animationTime / 2);
      } else {
        $right.hide();
      }
    });
  }

  function slideWords() {
    $track.css("transition", `transform ${animationTime}ms ease-in-out`);

    $words.removeClass("active");
    $words.eq(index).addClass("active");

    const offset = (index - 1) * wordHeight;
    $track.css("transform", `translateY(-${offset}px)`);

    updateImages($words.eq(index));
    index = index+1;
    const slideHeight = $words.first().outerHeight(true);
    if (index > $words.length) {
      $(".highlight-scroll").addClass("hidden");
      $(".highlight-scroll").fadeOut(500, function () {
        $track.css("transition", "none");
        index = 0;
        $track.css("transform", `translateY(-${index * slideHeight}px)`);
        $track[0].offsetHeight;
        $words.removeClass("active");
        $(".highlight-scroll").fadeIn(500, function () {
          setTimeout(() => {
            $track.css("transition", `transform ${animationTime}ms ease-in-out`);
            index = 1;
            $track.css("transform", `translateY(-${index-1 * slideHeight}px)`);
            $words.removeClass("active");
            $words.eq(index).addClass("active");
            updateImages($words.eq(index));
          }, 100);
        });
        $(".highlight-scroll").removeClass("hidden");
      });
    }
  }

  $words.eq(index).addClass("active");
  updateImages($words.eq(index));
  setInterval(slideWords, intervalTime);
});






// $(document).ready(function () {
//   const $track = $(".word-track");
//   const $words = $(".word-track .word");
//   const wordHeight = $(".word").outerHeight();
//   let index = 1;

//   function updateImages($word) {
//     const leftImg = $word.data("left");
//     const rightImg = $word.data("right");
//     $("#left-banner-img").attr("src", leftImg || "").toggle(!!leftImg);
//     $("#right-banner-img").attr("src", rightImg || "").toggle(!!rightImg);
//   }

//   function slideWords() {
//     $words.removeClass("active");
//     $words.eq(index).addClass("active");
//     const offset = (index - 1) * wordHeight;
//     $track.css("transform", `translateY(-${offset}px)`);

//     updateImages($words.eq(index)); // 🔄 Update image

//     index++;
//     if (index >= $words.length - 1) {
//       setTimeout(() => {
//         $track.css("transition", "none");
//         $track.css("transform", "translateY(0)");
//         index = 1;
//         $words.removeClass("active");
//         $words.eq(index).addClass("active");
//         updateImages($words.eq(index)); // 🔄 Reset image
//         setTimeout(() => {
//           $track.css("transition", "transform 0.6s ease-in-out");
//         }, 50);
//       }, 1000);
//     }
//   }

//   $words.eq(index).addClass("active");
//   updateImages($words.eq(index)); // Initial load
//   setInterval(slideWords, 1500);
// });

/*************************** read moore button scroll to faq code start**************************************** */ 

$(document).ready(function(){
  $(".scroll-to-faq").on("click", function(e){
    e.preventDefault(); // stop default jump
    const target = $("#faq-section");
    if (target.length) {
      $("html, body").animate({
        scrollTop: target.offset().top
      }, 2000); 
    }
  });
});

/*************************** read moore button scroll to faq code end**************************************** */ 



function initHiddenSugarSlider() {
  var $slider = $(".hidden-sugar-slider");

  // Destroy slick if already initialized
  if ($slider.hasClass("slick-initialized")) {
    $slider.slick("unslick");
  }

  // Reinitialize slick
  $slider.slick({
    centerMode: true,
    centerPadding: "150px",
    slidesToShow: 4,
    //arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/01.svg?v=1751026781" alt="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/02_1.svg?v=1751026978" alt="Next"></button>',
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          centerPadding: '100px'
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerPadding: '80px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: '40px'
        }
      }
    ]
  });
}

// Run on page load
$(document).ready(function () {
  initHiddenSugarSlider();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initHiddenSugarSlider();
  });
  document.addEventListener('shopify:block:select', function (event) {
    initHiddenSugarSlider();
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   $(".try-it-carousel").slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     infinite: true, // Enable loop even if not enough slides
//     prevArrow:
//       '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/01.svg?v=1751026781" alt="Previous"></button>',
//     nextArrow:
//       '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/02_1.svg?v=1751026978" alt="Next"></button>',
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//         },
//       },
//     ],
//   });
// });

function initTryItCarousel() {
  const $carousel = $(".try-it-carousel");

  if (!$carousel.length) return;

  // Destroy if already initialized
  if ($carousel.hasClass("slick-initialized")) {
    $carousel.slick("unslick");
  }

  // Reinitialize slick
  $carousel.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    infinite: true, // Loop even with fewer slides
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/01.svg?v=1751026781" alt="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/02_1.svg?v=1751026978" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initTryItCarousel();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    initTryItCarousel();
  });

  document.addEventListener("shopify:block:select", function () {
    initTryItCarousel();
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".meal-carousel").forEach((slider) => {
//     const id = "#" + slider.id;
//     $(id).slick({
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       arrows: true,
//       prevArrow:
//         '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/01.svg?v=1751026781" alt="Previous"></button>',
//       nextArrow:
//         '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/02.svg?v=1751026781" alt="Next"></button>',
//       dots: false,
//       infinite: false,
//       responsive: [
//         { breakpoint: 1024, settings: { slidesToShow: 2 } },
//         { breakpoint: 768, settings: { slidesToShow: 1 } },
//       ],
//     });
//   });
//   const buttons = document.querySelectorAll(".filter-btn");
//   buttons.forEach((button) => {
//     button.addEventListener("click", () => {
//       buttons.forEach((b) => b.classList.remove("active"));
//       button.classList.add("active");
//       const selectedCategory = button.getAttribute("data-target");
//       document.querySelectorAll(".meal-slider-wrapper").forEach((wrapper) => {
//         const isMatch =
//           wrapper.getAttribute("data-category") === selectedCategory;
//         wrapper.style.display = isMatch ? "block" : "none";
//         if (isMatch) {
//           const slider = wrapper.querySelector(".meal-carousel");
//           if (slider && $(slider).hasClass("slick-initialized")) {
//             setTimeout(() => {
//               $(slider).slick("setPosition");
//             }, 100); // delay helps DOM layout settle
//           }
//         }
//       });
//     });
//   });
// });
function initMealCarousels() {
  document.querySelectorAll(".meal-carousel").forEach((slider) => {
    const id = "#" + slider.id;

    if ($(id).hasClass("slick-initialized")) {
      $(id).slick("unslick");
    }

    $(id).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/01.svg?v=1751026781" alt="Previous"></button>',
      nextArrow:
        '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/02.svg?v=1751026781" alt="Next"></button>',
      dots: false,
      infinite: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
      ],
    });
  });
}

function handleMealCarouselFilters() {
  const buttons = document.querySelectorAll(".filter-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      // Update active button
      buttons.forEach((b) => b.classList.remove("active"));
      button.classList.add("active");

      const selectedCategory = button.getAttribute("data-target");

      document.querySelectorAll(".meal-slider-wrapper").forEach((wrapper) => {
        const isMatch = wrapper.getAttribute("data-category") === selectedCategory;

        if (isMatch) {
          const slider = wrapper.querySelector(".meal-carousel");

          // Show wrapper and hide temporarily to allow smooth update
          wrapper.style.display = "block";
          wrapper.style.visibility = "hidden";

          if (slider && $(slider).hasClass("slick-initialized")) {
            requestAnimationFrame(() => {
              $(slider).slick("setPosition");
              wrapper.style.visibility = "visible";
            });
          } else {
            wrapper.style.visibility = "visible";
          }
        } else {
          wrapper.style.display = "none";
        }
      });
    });
  });
}

// Run on page load
$(document).ready(function () {
  initMealCarousels();
  handleMealCarouselFilters();
});

// Shopify Customizer support
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    initMealCarousels();
    handleMealCarouselFilters();
  });

  document.addEventListener("shopify:block:select", function () {
    initMealCarousels();
  });
}


// document.addEventListener("DOMContentLoaded", function () {
//   const $slider = $(".powerful-slider");
//   const $current = document.querySelector(".powerful-pagination .current");
//   const $total = document.querySelector(".powerful-pagination .total");
//   const $progress = document.querySelector(".powerful-progress .progress-bar");

//   $slider.on("init reInit afterChange", function (event, slick, currentSlide) {
//     let i = (currentSlide ? currentSlide : 0) + 1;
//     $current.textContent = i;
//     $total.textContent = slick.slideCount;

//     const progressPercent = (i / slick.slideCount) * 100;
//     $progress.style.width = progressPercent + "%";
//   });

//   $slider.slick({
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: false,
//     infinite: false,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//         },
//       },
//     ],
//   });

//   document
//     .querySelector(".powerful-prev")
//     .addEventListener("click", function () {
//       $slider.slick("slickPrev");
//     });

//   document
//     .querySelector(".powerful-next")
//     .addEventListener("click", function () {
//       $slider.slick("slickNext");
//     });
// });
function initPowerfulSlider() {
  const $slider = $(".powerful-slider");

  // Only run if slider exists
  if (!$slider.length) return;

  // Destroy Slick if already initialized
  if ($slider.hasClass("slick-initialized")) {
    $slider.slick("unslick");
  }

  const $current = document.querySelector(".powerful-pagination .current");
  const $total = document.querySelector(".powerful-pagination .total");
  const $progress = document.querySelector(".powerful-progress .progress-bar");

  $slider.on("init reInit afterChange", function (event, slick, currentSlide) {
    let i = (currentSlide ? currentSlide : 0) + 1;
    if ($current) $current.textContent = i;
    if ($total) $total.textContent = slick.slideCount;

    const progressPercent = (i / slick.slideCount) * 100;
    if ($progress) $progress.style.width = progressPercent + "%";
  });

  $slider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  // Bind navigation buttons
  const $prev = document.querySelector(".powerful-prev");
  const $next = document.querySelector(".powerful-next");

  if ($prev) {
    $prev.addEventListener("click", function () {
      $slider.slick("slickPrev");
    });
  }

  if ($next) {
    $next.addEventListener("click", function () {
      $slider.slick("slickNext");
    });
  }
}

// Initial load
document.addEventListener("DOMContentLoaded", function () {
  initPowerfulSlider();
});
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    initPowerfulSlider();
  });
  document.addEventListener("shopify:block:select", function () {
    initPowerfulSlider();
  });
}

$(document).ready(function () {
  const animateCount = (el) => {
    const $el = $(el);
    const target = parseInt($el.data("number"));
    let current = 0;
    const duration = 1000;
    const increment = target / (duration / 16); // ~60fps

    const counter = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(counter);
      }
      $el.text(Math.floor(current));
    }, 16);
  };

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  $(".powerful-number").each(function () {
    observer.observe(this);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  $(".reading-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/01.svg?v=1751026781" alt="Previous"></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/02.svg?v=1751026781" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   $(".faq-question").on("click", function () {
//     var $item = $(this).closest(".faq-item");

//     if (!$item.hasClass("active")) {
//       $(".faq-item").removeClass("active");
//       $(".faq-answer").slideUp();
//       $item.addClass("active");
//       $item.find(".faq-answer").slideDown();
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  let fromCard = false;
  let clickedCardSelector = null;

  // Handle FAQ toggles
  $(".faq-question").on("click", function () {
    var $item = $(this).closest(".faq-item");

    // Remove any existing back links if FAQ opened manually
    $(".back-to-card").remove();

    if (!$item.hasClass("active")) {
      $(".faq-item").removeClass("active");
      $(".faq-answer").slideUp();
      $item.addClass("active");
      $item.find(".faq-answer").slideDown();
    }

    fromCard = false;
  });

  // Feel-card click triggers scroll and opens the matching FAQ
  $(".feel-card").on("click", function (e) {
    e.preventDefault();

    fromCard = true;
    clickedCardSelector = this;

    var targetSlug = $(this).attr("data-click");
    var $faqTarget = $('.faq-item[data-target="' + targetSlug + '"]');

    const topBtn = document.getElementById("faqTopBtn");

const BACK_TEXT = topBtn?.childNodes[0]?.textContent.trim();
console.log(BACK_TEXT);

    if ($faqTarget.length) {
      // Close all first
      $(".faq-item").removeClass("active");
      $(".faq-answer").slideUp();
      $(".back-to-card").remove();

      // Open the matched FAQ
      $faqTarget.addClass("active");
      let $answer = $faqTarget.find(".faq-answer");
      $answer.slideDown(300, function () {
        // Scroll after the answer is fully visible
        $('html, body').animate({
          scrollTop: $faqTarget.offset().top - 100
        }, 2000, function () {
          if (fromCard) {
            let backLink = $(`
              <a href="#" class="site-btn back-to-card">
                ${BACK_TEXT}
                <span class="arrow">
                  <img src="https://cdn.shopify.com/s/files/1/0742/2630/3197/files/brn-arrow-white.svg?v=1751017155">
                </span>
              </a>
            `);

            $answer.append(backLink);

            backLink.on("click", function (e) {
              e.preventDefault();
              $faqTarget.removeClass("active");
              $faqTarget.find(".faq-answer").slideUp();
              $('html, body').animate({
                scrollTop: $(clickedCardSelector).offset().top - 100
              }, 1500);
              $(this).remove();
              fromCard = false;
            });
          }
        });
      });
    }
  });
});



$(document).ready(function () {
  $(".card_link").on("click", function (e) {
    e.preventDefault(); // Prevent default anchor behavior
    const target = $(this).attr("href"); // Get target section ID
    const offset = $(target).offset(); // Get offset position of target
    if (offset) {
      $("html, body").animate(
        {
          scrollTop: offset.top,
        },
        600
      ); // Scroll duration in milliseconds
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".after-before-container");
  const slider = document.querySelector(".slider-range");
  if (slider && container) {
    slider.addEventListener("input", (e) => {
      container.style.setProperty("--position", `${e.target.value}%`);
    });
  }
});

//video popup

// document.addEventListener("DOMContentLoaded", function () {
//   const modal = document.getElementById("videoModal");
//   const iframe = document.getElementById("videoFrame");
//   const closeBtn = modal.querySelector(".video-close");

//   document.querySelectorAll(".play-video").forEach((btn) => {
//     btn.addEventListener("click", function (e) {
//       e.preventDefault();
//       const videoUrl = this.dataset.src;
//       iframe.src = videoUrl.includes("?")
//         ? videoUrl + "&autoplay=1"
//         : videoUrl + "?autoplay=1";
//       modal.style.display = "flex";
//     });
//   });

//   closeBtn.addEventListener("click", function () {
//     modal.style.display = "none";
//     iframe.src = "";
//   });

//   modal.addEventListener("click", function (e) {
//     if (e.target === modal) {
//       modal.style.display = "none";
//       iframe.src = "";
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("videoModal");
  const iframe = document.getElementById("videoFrame");
  const closeBtn = modal.querySelector(".video-close");

  document.querySelectorAll(".play-video").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      let videoUrl = this.dataset.src;
      let embedUrl = videoUrl;
      if (videoUrl.includes("youtube.com/watch")) {
        const videoId = videoUrl.split("v=")[1].split("&")[0];
        embedUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
      }
      else if (videoUrl.includes("youtu.be")) {
        const videoId = videoUrl.split("youtu.be/")[1];
        embedUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
      }
      else {
        embedUrl = videoUrl.includes("?")
          ? videoUrl + "&autoplay=1"
          : videoUrl + "?autoplay=1";
      }

      iframe.src = embedUrl;
      modal.style.display = "flex";
    });
  });
  closeBtn.addEventListener("click", function () {
    modal.style.display = "none";
    iframe.src = "";
  });
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
      iframe.src = "";
    }
  });
});
$(document).ready(function () {
  function revealOnScroll() {
    $(".scroll-effect").each(function () {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height();

      if (elementTop < windowBottom - 100) {
        $(this).addClass("visible");
      }
    });
  }

  revealOnScroll(); // Run on page load
  $(window).on("scroll", revealOnScroll); // Run on scroll
});
$(document).ready(function () {
  function revealOnScroll() {
    $(".scroll-animate").each(function () {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height();

      if (elementTop < windowBottom - 100) {
        $(this).addClass("visible");
      }
    });
  }

  revealOnScroll();
  $(window).on("scroll", revealOnScroll);
});



// document.addEventListener("DOMContentLoaded", function() {
//   // mapping for market-options ID → country ID
//   const mapping = {
//     us: "United States",
//     apac: "China",
//     emea: "Germany"
//   };
//   document.querySelectorAll(".market-options div").forEach(option => {
//     option.addEventListener("click", function() {
//       const targetCountryId = mapping[this.id];
//       if (targetCountryId) {
//         const countryEl = document.querySelector(`.countries #${CSS.escape(targetCountryId)}`);
//         console.log(countryEl)
//         if (countryEl) {
//           countryEl.click(); // trigger the click
//         }
//       }
//     });
//   });
// });
// (function() {
//   const dropdown = document.getElementById('marketDropdown');
//   const selected = dropdown.querySelector('.market-selected');
//   const label = dropdown.querySelector('.market-label');
//   const options = dropdown.querySelectorAll('.market-options div');
//   selected.addEventListener('click', () => {
//     dropdown.classList.toggle('open');
//   });
//   options.forEach(option => {
//     option.addEventListener('click', () => {
//       label.textContent = option.textContent; // Set label
//       dropdown.classList.remove('open'); // Close dropdown
//     });
//   });
//   const currentURL = window.location.href;
//   let matched = false;
//   options.forEach(option => {
//     const url = option.getAttribute('data-url');
//     if (currentURL.startsWith(url)) {
//       label.textContent = option.textContent;
//       matched = true;
//     }
//   });
//   if (!matched) {
//     label.textContent = 'Select Market';
//   }
//   document.addEventListener('click', (e) => {
//     if (!dropdown.contains(e.target)) {
//       dropdown.classList.remove('open');
//     }
//   });
// })();
document.addEventListener("DOMContentLoaded", function() {
  // mapping for market-options ID → country ID
  const mapping = {
    us: "United States",
    apac: "China",
    emea: "Germany"
  };

  // Loop through all dropdowns (header + footer)
  document.querySelectorAll(".market-dropdown").forEach(dropdown => {
    const selected = dropdown.querySelector('.market-selected');
    const label = dropdown.querySelector('.market-label');
    const options = dropdown.querySelectorAll('.market-options div');

    // Toggle open/close
    selected.addEventListener('click', () => {
      dropdown.classList.toggle('open');
    });

    // Handle option click
    options.forEach(option => {
      option.addEventListener('click', () => {
        // Update label
        label.textContent = option.textContent;
        dropdown.classList.remove('open');

        // Trigger country selection if mapping exists
        const targetCountryId = mapping[option.id];
        if (targetCountryId) {
          const countryEl = document.querySelector(`.countries #${CSS.escape(targetCountryId)}`);
          if (countryEl) {
            countryEl.click();
          }
        }
      });
    });

    // Preselect based on URL
    const currentURL = window.location.href;
    let matched = false;
    options.forEach(option => {
      const url = option.getAttribute('data-url');
      if (currentURL.startsWith(url)) {
        label.textContent = option.textContent;
        matched = true;
      }
    });
    if (!matched) {
      label.textContent = 'Select Market';
    }

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });
  });
});

/********************* Translation code for header and footer form ***************************************************/

// $(document).ready(function () {


//   // SWITCH/Toggle
//   if (!window.marketLanguageSync) {
//     console.log("Translation OFF → Shopify default working");
//     return; 
//   }

//   console.log("Translation ON");

//     // Hide Shopify localization UI
//     $('#HeaderLanguageForm').closest('localization-form').hide();
//     $('#HeaderCountryForm').closest('localization-form').hide();
//     $('#FooterLanguageForm').closest('localization-form').hide();

//     // -------------------------------
//     // SET LABEL BASED ON CURRENT URL
//     // -------------------------------
//     function setMarketLabelFromUrl() {
//         let path = window.location.pathname.toLowerCase();
//         console.log(path);
//         let label = 'Americas';

//         if (path.includes('apac')) {
//             label = 'Asia';
//         }
//         else if (path.includes('emae') || path.includes('emea')) {
//             label = 'Europe';
//         }

//         $('#marketSelected .market-label').text(label);
//     }

//     setMarketLabelFromUrl();

//     // -------------------------------
//     // MARKET CLICK HANDLER
//     // -------------------------------
//     $('.market-options div').on('click', function () {

//         let marketId = $(this).attr('id');
//         let selectedLabel = $(this).text();
//         let marketUrl = '/';

//         if (marketId === 'us') {
//             marketUrl = '/';
//         }
//         else if (marketId === 'apac') {
//             marketUrl = '/es-apac';
//         }
//         else if (marketId === 'emea') {
//             marketUrl = '/fr-emea';
//         }

//         $('#marketSelected .market-label').text(selectedLabel);
//         $('.market-options').removeClass('open');

//         window.location.href = marketUrl;

//     });

// });
